import React from 'react';
import ApplyCoupon from '../ApplyCoupon/ApplyCoupon';

export default function ApplyCouponWrapper({ customer, customerUid, setCustomer, onCouponRedeemed }) {
    // Pass the customer from QuickLink to ApplyCoupon so it can use the selected customer
    return (
        <ApplyCoupon hideHeader={true} customer={customer} customerUid={customerUid} onCouponRedeemed={onCouponRedeemed} />
    );
}

